var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e3d3c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.9,38.1H2l.45-5.22h5c2.28,0,3.69-1.29,4-4.38L13.84.9h5.79s-2.4,27.33-2.43,27.6C16.77,33,13.72,38.1,6.9,38.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.74,38.1h3.81L60,32.88H56.11c-2.27,0-3.45-1.29-3.17-4.38L55.5.9H49.72s-2.53,27.33-2.55,27.6C46.78,33,48.92,38.1,55.74,38.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81,.9H75.16L73.77,16.83c-.28,3.1-1.7,4.49-4,4.49s-3.51-1.39-3.23-4.49L68,.9H62.15L60.73,17s-1.2,9.11,8.6,9.51A9.47,9.47,0,0,0,73,25.92l-.23,2.58c-.27,3.1-1.69,4.38-4,4.38h-5l-.45,5.22h4.95s9.21.16,10.23-9.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.23,38.1s9.2.16,10.22-9.6L43.88.9H38.07L35.66,28.5c-.27,3.1-1.69,4.38-4,4.38s-3.51-1.28-3.24-4.38L30.86.9H25.05s-2.4,27.21-2.43,27.6C22.59,29.3,21.64,38.1,31.23,38.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c1f993c64734755969450810d1c41dc6.svg";
export { ForwardRef as ReactComponent };